import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactReactionDetailsHelper from '@Components/Results/services/react-reaction-details-helper.service';

export default class TargetCell extends React.PureComponent {

  render() {
    const { metadata, value } = this.props;

    return (
      value && (
        <span className='rx-table-targets-list'>
          {value.map((data, index) =>
            data ? (
              <span key={index}>
                <InnerHTML
                  tag="a"
                  onClick={() =>
                    ReactReactionDetailsHelper.goToContext('tgitems', { targetId: data.targetId }, metadata)
                  }
                  html={data.targets}
                />
              </span>
            ) : null,
          )}
        </span>
      )
    );
  }
}

TargetCell.propTypes = {
  metadata: MetadataPropTypesShape,
  value: PropTypes.array.isRequired,
};
